import { api } from '_api';

import type { Finder, Mutator } from '_types/swr';

import { NoContent } from "_types";
import { Conference } from '_types/models/Conference';
import { EndConference, StoreConference } from '_types/requests/Client/conference';
import type { GeneratedChatToken } from "_types/responses/generated-chat-token";
import { unwrap } from '_utils/axios';
import { parseKey } from '_utils/swr';

export const findConference: Finder<Conference> = async ({queryKey}) => {
    const url = parseKey(queryKey);
    const response = await api.get<Conference>(url);

    return await unwrap(response);
};

export const storeConference: Mutator<Conference, StoreConference> = async (queryKey, payload) => {

    const url = parseKey(queryKey);
    const response = await api.post<Conference>(url, payload);
    return await unwrap(response);
}

export const chatToken: Mutator<GeneratedChatToken> = async (queryKey, payload) => {

    const url = parseKey(queryKey);
    const response = await api.post<GeneratedChatToken>(url, payload);
    return await unwrap(response);
}

export const endConference: Mutator<NoContent, EndConference> = async (queryKey, payload) => {

    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url, payload);
    return await unwrap(response);
}

export const npsConference: Mutator<NoContent, EndConference> = async (queryKey, payload) => {

    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url, payload);
    return await unwrap(response);
}
